import { getData, postData, delData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

interface UserMeRequest {
  //
}

interface UserProfileRequest {
  //
}

interface UserMeResponse {
  firstName: string;
  marketAccess: string | null;
}

interface UserBlacklistResponse {
  email: string;
}

export const getUserMeInfoRepository = async (): Promise<UserMeResponse> => {
  const response = await getData<UserMeRequest, UserMeResponse>(
    API_URLS.USER_ME,
    undefined,
    undefined,
    process.env.REACT_APP_LOGIN_ADMIN_PORTAL_CLIENT_ID,
  );
  return response.data as UserMeResponse;
};

export const getUserProfileRepository = async (url: string, email: string): Promise<any> => {
  const urlUser = `${url}/${email}`;
  const response = await getData<UserProfileRequest, any>(urlUser);
  return response.data;
};

export const postActiveUserRepository = async (id: string): Promise<any> => {
  return postData(API_URLS.USER_ACTIVE_REMOVE_WITH_ID(id), {});
};

export const postUpdateUserProfileRepository = async (id: string, payload: any): Promise<any> => {
  return postData(API_URLS.USER_PROFILE_UPDATE(id), payload);
};

export const deleteUserRepository = async (id: string): Promise<any> => {
  return delData(API_URLS.USER_ACTIVE_REMOVE_WITH_ID(id));
};

export const postAddUserBlacklistRepository = async (payload: UserBlacklistResponse): Promise<any> => {
  return postData(API_URLS.USER_BLACKLIST, payload);
};

export const deleteUserBlackListRepository = async (id: string): Promise<any> => {
  return delData(API_URLS.DELETE_USER_BLACKLIST(id));
};
